import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function BrazeIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box as="g" clipPath={`url(#braze-a-${id})`}>
        <Box
          as="path"
          fill="#212124"
          d="M9.035 11.453c.164-1.562 1.145-2.836 2.29-2.836 1.144 0 1.76 1.274 1.6 2.836-.16 1.563-1.109 2.856-2.183 2.856-1.07 0-1.941-.98-1.707-2.856ZM10 18.547a8.521 8.521 0 0 1-6.582-3.09c1.418.453 3 .055 4.238-1.164.13-.133.254-.27.364-.418.562 1.219 1.656 1.836 2.746 1.836 1.855 0 3.418-1.91 3.601-4.274.184-2.363-1.144-4.238-2.91-4.238-.64-.008-1.27.16-1.816.492l.546-3.183a.882.882 0 0 0-.164-.727c-.164-.254-.308-.363-.527-.363H6.95a.306.306 0 0 0-.289.273 7.15 7.15 0 0 0-.144.91c-.02.2.129.274.289.274H8.66c-.289 1.816-.87 5.344-1.035 6.238a4.49 4.49 0 0 1-1.184 2.239c-1.02 1.02-2.89 1.253-4 .144-.386-.406-.988-1.387-.988-3.496A8.546 8.546 0 0 1 10 1.453 8.546 8.546 0 0 1 18.547 10 8.549 8.549 0 0 1 10 18.547ZM10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0Z"
        />
      </Box>
      <Box as="defs">
        <clipPath id={`braze-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
